<script lang="ts">
    export let address: Address

    let name = ""
    $: {
        if (address) {
            let addr = ""
            if (address.type == "person") {
                addr += address?.person?.salutation + " " + address?.person?.firstname + " " + address?.person?.lastname
            } else {
                addr += address?.company?.name
            }
            name = addr
        }
    }
</script>

{#if name}
    {name}
{/if}
